// extracted by mini-css-extract-plugin
module.exports =  {"gwMediaSidebarTextContainer":"TextComponent_gwMediaSidebarTextContainer__ihPMv"};